import moment from 'moment';
import numeral from 'numeral';
import 'numeral/locales';
import h from 'virtual-dom/h';
import { listviewDefaults, listviewColumnActionDefaults, listviewRenderTypeDefaults } from './listview';
import Inputmask from 'inputmask';

numeral.locale('nl-nl');

listviewDefaults.tableProps = { className: 'table table-striped table-hover' };
listviewDefaults.noResults = () => 'No results';
listviewColumnActionDefaults.confirmButtonProps = { className: 'btn btn-sm btn-success' };
listviewColumnActionDefaults.cancelButtonProps = { className: 'btn btn-sm btn-danger' };
listviewColumnActionDefaults.confirmButtonContent = h('i', { className: 'fa fa-check', title: 'Confirm' }, []);
listviewColumnActionDefaults.cancelButtonContent = h('i', { className: 'fa fa-times', title: 'Cancel' }, []);

listviewRenderTypeDefaults.datetime = (value: string, format: any) => {
    var date = moment(value);
    var formattedDate = date.format(format);
    return formattedDate;
};
listviewRenderTypeDefaults.number = (value: number, format: any) => {
    var num = numeral(value);
    var formattedNumeral = num.format(format);
    return formattedNumeral;
}
listviewRenderTypeDefaults.currency = (value: number, format: any) => {
    var num = numeral(value);
    format = `$${format}`;
    var formattedNumeral = num.format(format);
    return formattedNumeral;
}

[].forEach.call(document.getElementsByClassName('integer'), (element: any) => {
    Inputmask('integer', {
        rightAlign: false,
        autoGroup: true,
        groupSeparator: '.'
    }).mask(element);
});

[].forEach.call(document.getElementsByClassName('decimal'), (element: any) => {
    Inputmask('decimal', {
        rightAlign: false,
        autoGroup: true,
        digits: 2,
        radixPoint: ',',
        groupSeparator: '.'
    }).mask(element);
});

listviewRenderTypeDefaults.nullableDatetime = (value: string, format: any) => {
    if (value) {
        return listviewRenderTypeDefaults.datetime(value, format);
    }
    return '-';
}

const html = document.documentElement;
const popups = <HTMLElement[]>Array.from(document.getElementsByClassName('popup'));
const popupToggles = <HTMLElement[]>Array.from(document.getElementsByClassName('toggle-popup'));
const popupCloses = <HTMLElement[]>Array.from(document.getElementsByClassName('close-popup'));
const backfaces = <HTMLElement[]>Array.from(document.getElementsByClassName('backface'))
    .filter((element) => !element.classList.contains('no-close'));

popupToggles.forEach(element => {
    element.addEventListener('click', (e: Event) => {
        e.preventDefault();
        closePopups();

        let toggleId = element.dataset.toggle;
        if (toggleId) {
            if (toggleId.startsWith('#')) {
                toggleId = toggleId.substring(1);
            }

            const target = document.getElementById(toggleId);
            if (target) {
                html.classList.add('popup-open');
                target.classList.add('open');
                html.querySelector('.backface')!.classList.add('open');
            }
        }
    });
});

[...popups, ...backfaces].forEach(element => {
    element.classList.add('loaded');
});

[...popupCloses, ...backfaces].forEach(element => {
    element.addEventListener('click', (e: Event) => {
        e.preventDefault();
        closePopups();
    });
});

export function closePopups() {
    html.classList.remove('popup-open');
    popups.forEach(popup => popup.classList.remove('open'));
    backfaces.forEach(backface => backface.classList.remove('open'));
}

export function openPopup(name: string) {
    const target = document.getElementById(name);

    if (target) {
        document.documentElement.classList.add('popup-open');
        target.classList.add('open');
        document.documentElement.querySelector('.backface')!.classList.add('open');
    }
}
